var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex border text-gray-900"},[_c('div',{staticClass:"w-1/2 border-r border-gray-200"},[_c('CompanyStatusDropdown')],1),_c('div',{staticClass:"w-1/2"},[_c('CompanyManagerDropdown')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }